import Menu from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, memo, useCallback } from 'react';

import { COLOR } from '../types/theme';
import { colorToCss } from '../utils/theme';

const SX_CLOSED: SxProps<Theme> = {
  color: colorToCss(COLOR.Highlight),
};

type MobileButtonProps = {
  mode: 'close' | 'open';
  onClick: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const MobileMenuButton: FC<MobileButtonProps> = ({ mode, onClick }) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>): void => onClick(e),
    [onClick]
  );

  return (
    <IconButton
      aria-controls='menu-appbar'
      aria-haspopup={mode === 'open' ? 'true' : 'false'}
      aria-label={`${mode} menu`}
      className='menu-button'
      onClick={handleClick}
      sx={mode === 'close' ? SX_CLOSED : {}}
    >
      <Menu sx={{ height: '30px', width: '30px' }} />
    </IconButton>
  );
};

export default memo(MobileMenuButton);
